import template from './radialProgressBar.html';
import controller from './radialProgressBar.controller';

let radialProgressBarComponent = {
  restrict: 'E',
  bindings: {
    stepProgress: '=',
    stepError: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default radialProgressBarComponent;



// WEBPACK FOOTER //
// ./app/components/radialProgressBar/radialProgressBar.component.js